<template lang="jade">
 div.Input(":tooltip"="fdata.tip || false"
            v-bind:class="{'Input--filled': formInput, 'Input--invalid': error, 'Input--valid': complete }"
            ":skin"="skins.inputs")
    div.Input__group(style="display: flex")
      input.Input__field(":id"="fdata.id"
                         v-for="n in fdata.columns"
                         type="text"
                         ":name"="fdata.content[0].field"
                         @paste="paste"
                         @keydown="mask"
                         @keyup="autoTab"
                         @change="dispatch"
                         v-model="formInput[n]"
                         "required"="true")
    label.Input__label
      span.Input__label-content(v-bind:class="{'Input__label-content--required': required }")
        span.Input__icon
        {{ input.label }}

</template>

<script>
import { addNotification, removeNotification } from 'src/vuex/actions'
import { skins, forms } from 'src/vuex/getters'
import _ from 'lodash'

export default {
  data () {
    return {
      formInput: Array(this.fdata.columns),
      keymap: ['Delete', 'Backspace', 'Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'],
      attempts: 1,
      uid: this.$parent.uid,
      error: false,
      externalError: false,
      complete: false
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce: x => {
        let columns = 3 // hard coded need to make dynamic
        let max = 2 // hard coded need to make dynamic
        let mask = _.filter(x.content[0].validation, xs => xs.rule.split(':')[0] === 'mask')
        let pattern = null
        if (mask.length > 0) {
          mask = mask[0].rule.split(':')[1]
          let flags = mask.replace(/.*\/([gimy]*)$/, '$1')
          pattern = mask.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1')
        }
        x.content[0].validation = _.filter(x.content[0].validation, xs => xs.rule.split(':')[0] !== 'mask')
        let input = x.content[0]
        return Object.assign({}, x, {columns, max, input, pattern})
      },
      required: true
    }
  },
  vuex: {
    getters: {
      skins,
      forms
    },
    actions: {
      addNotification,
      removeNotification
    }
  },
  computed: {
    input () {
      return this.fdata.content[0]
    },

    required () {
      return _.some(this.fdata.content[0].validation, ['rule', 'required'])
    }
  },
  events: {
    'force::validate': 'validate'
  },
  methods: {
    paste (e) {
      let clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData
      let pastedData = clipboardData.getData('text')
      if (this.isInvalidChar(pastedData) || this.maxLength(pastedData, 2)) {
        e.preventDefault()
        return false
      }
      return true
    },

    mask (e) {
      if (!this.fdata.pattern) return false
      let key = e.key
      if (this.metaKey(e) || this.allowedKeys(key)) return true
      if (this.isInvalidChar(key) || this.maxLength(e.target.value, 2)) {
        e.preventDefault()
        return false
      }
      return true
    },

    allowedKeys (key) {
      return _.includes(this.keymap, key)
    },

    maxLength (val, limit) {
      let selection = window.getSelection().toString()
      return selection.length > limit || (!selection && val.length >= limit)
    },

    isInvalidChar (key) {
      let regex = new RegExp(this.fdata.pattern)
      return !regex.test(key)
    },

    metaKey (e) {
      return e.ctrlKey || e.metaKey
    },

    autoTab (e) {
      let selection = window.getSelection().toString()
      if (e.ctrlKey || e.metaKey || !_.isEmpty(selection)) return true
      let el = e.target
      let inputs = document.querySelectorAll('input')
      let idx = _.findIndex(inputs, el)

      if (el.value.length >= this.fdata.max && idx) {
        inputs[(idx + 1)].focus()
      }
    },

    validate () {
      if (!this.fdata.input.validation) return this.dispatch()
      // let inputs = _.filter(this.formInput, x => x)
      let validated = this.computedValidate(this.fdata.input, this.formInput.join(''))
      this.fieldState(validated)
      this.notice('error', validated)
    },

    notice (type, valid) {
      _.isNil(valid) || _.isEmpty(valid)
        ? this.removeNotification(this.fdata.input.field)
        : this.addNotification({
          type: type,
          msg: valid,
          id: this.fdata.input.field,
          show: this.attempts > 0
        })

      this.dispatch()
    },
    fieldState (valid) {
      _.isNil(valid) ? this.setFieldComplete() : this.setFieldError()
    },

    setFieldComplete () {
      this.$set('complete', true)
      this.$set('error', false)
    },

    setFieldError () {
      this.$set('error', true)
      this.$set('complete', false)
    },

    dispatch () {
      if (this.fdata.input.field) {
        this.$dispatch('fdata::input', {
          [this.fdata.input.field]: this.formInput.join('')
        })
      }
    }
  },
  ready () {
    let vuex = _.find(this.forms, ['uid', this.uid])
    if (vuex) {
      let formData = vuex.data[this.fdata.input.field]
      if (formData) {
        this.fdata.input.value = formData
      }
    }
    if (this.fdata.input.value) {
      if (this.fdata.input.value.indexOf('-') !== -1) {
        this.fdata.input.value.split('-').forEach((xs, idx) => {
          this.$set(`formInput[${idx}]`, xs)
        })
      } else {
        _.chunk(this.fdata.input.value.split(''), 2).forEach((xs, idx) => {
          this.$set(`formInput[${idx}]`, xs.join(''))
        })
      }
      this.validate()
    }
  }
}
</script>




// WEBPACK FOOTER //
// split.vue?3efee0d8